import { CustomerVehicleIconType } from "JS/types/Automotive";
import { DetailsStep, TireSizeStep, TrimStep, VehicleStep } from "../types/steps";

export function createVehicleStepData(): VehicleStep['data'] {
	return {
		availableYears: [],
		availableMakes: [],
		availableModels: [],
		year: null,
		make: null,
		model: null,
	};
}

export function createTrimStepData(): TrimStep['data'] {
	return {
		availableTrims: [],
		trim: null,
	};
}

export function createTireSizeStepData(): TireSizeStep['data'] {
	return {
		availableSizes: [],
		size: null,
	};
}

export function createDetailsStepData(): DetailsStep['data'] {
	return {
		icon: null,
		color: '',
		nickname: '',
		availableColors: [
			'black',
			'blue',
			'brown',
			'default',
			'gold',
			'gray',
			'green',
			'white',
			'red',
		],
		availableIcons: [CustomerVehicleIconType.Car, CustomerVehicleIconType.Truck, CustomerVehicleIconType.SUV, CustomerVehicleIconType.Van],
	};
}